import { useState, useMemo, useCallback, useRef, useEffect } from "react";
import styled from 'styled-components'

const FrequencyInput = ({handleInputChange, timeframe, taskId, currentValue}) => {
  const [value, setValue] = useState("");
  const [unit, setUnit] = useState("seconds");

    const [inputValue, setInputValue] = useState("");

    const timeMultipliers = useMemo(() => ({
      seconds: 1,
      minutes: 60,
      hours: 3600,
      days: 86400,
      weeks: 604800,
      months: 2592000, // Approximate: 30 days
    }), []);
  
    // 🌟 Sync input state with `currentValue` from parent (when it changes)
    useEffect(() => {
      if (!currentValue || isNaN(currentValue)) {
        setInputValue(""); // Reset if no valid value
        setUnit("seconds");
        return;
      }
  
      const units = ["seconds", "minutes", "hours", "days", "weeks", "months"];
      let bestUnit = "seconds";
      let bestValue = currentValue;
  
      for (const unit of units) {
        const converted = currentValue / timeMultipliers[unit];
        if (converted >= 1 && Number.isInteger(converted)) {
          bestUnit = unit;
          bestValue = converted;
        }
      }
  
      setInputValue(bestValue.toString()); // ✅ Update input field
      setUnit(bestUnit); // ✅ Set best matching unit
    }, [currentValue, timeMultipliers]);


  const lastSentValue = useRef(null);
  // Memoizamos la función para evitar que se recree en cada render
  const updateTotalSeconds = useCallback((val, selectedUnit) => {
    const numericValue = parseFloat(val);
    const totalSeconds = !isNaN(numericValue) ? numericValue * timeMultipliers[selectedUnit] : 0;
  
    if (lastSentValue.current !== totalSeconds) {
      lastSentValue.current = totalSeconds;
      handleInputChange( timeframe, totalSeconds);
    }
  }, [handleInputChange, taskId, timeframe, timeMultipliers]);

  return (
    <Wrapper>
      <Input
        type="number"
        value={inputValue}
        onChange={(e) => {
          setValue(e.target.value);
          updateTotalSeconds(e.target.value, unit);
        }}
        placeholder="Enter a number"
      />
      <Select
        value={unit}
        onChange={(e) => {
          setUnit(e.target.value);
          updateTotalSeconds(value, e.target.value);
        }}
      >
        <option value="seconds">Seconds</option>
        <option value="minutes">Minutes</option>
        <option value="hours">Hours</option>
        <option value="days">Days</option>
        <option value="weeks">Weeks</option>
        <option value="months">Months</option>
      </Select>
    </Wrapper>
  );
};

export default FrequencyInput;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const Input = styled.input`
  background: transparent;
  border: 2px solid #5f5d62;
  border-radius: 10px;
  color: #fff;
  font-family: 'DMSans';
  font-size: 13px;
  height: 34px;
  padding: 10px 10px;
  width: 140px;
  text-align: center;
  outline: none;
  transition: border-color 0.15s;

  &:focus {
    border-color: rgba(111, 92, 230, 0.5);
    box-shadow: 0 0 0 3px rgba(111, 92, 230, 0.1);
  }

  &:focus {
    border-color: #0070f3;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }
`

const Select = styled.select`
  background: transparent;
  border: 2px solid #5f5d62;
  border-radius: 10px;
  color: #fff;
  font-family: 'DMSans';
  font-size: 13px;
  height: 34px;
  padding: 0 10px;
  width: 130px;
  text-align: center;
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: #0070f3;
  }

  option {
    background: #2e2c3e;
  }
`;
